const transformToDigitalAuthContext = (jutroAuthContext, token) => {
    return {
        ...jutroAuthContext,
        user_id: jutroAuthContext.userInfo?.sub,
        user_name: jutroAuthContext.userInfo?.name,
        name: jutroAuthContext.userInfo?.name,
        email: jutroAuthContext.userInfo?.email,
        email_verified: jutroAuthContext.userInfo?.email_verified,
        previous_logon_time: jutroAuthContext.userInfo?.updated_at,
        sub: jutroAuthContext.userInfo?.sub,
        accessToken: token,
        authHeader: {
            Authorization: `Bearer ${token}`,
        },
        isAuthInProgress: false,
        isLoggedIn: true,
        logout: jutroAuthContext.logout,
        useJutroAuthContext: true,
        authenticated: jutroAuthContext.isAuthenticated
    };
};

const getDigitalAuthContext =  jutroAuth => {
        const { accessToken } = jutroAuth;

        return transformToDigitalAuthContext(jutroAuth, accessToken);
};

export default {
    transformToDigitalAuthContext,
    getDigitalAuthContext
};
